import React from 'react'
import "./HowToUsePanel.scss"
const HowToUsePanel = () => {
    return (
        <div className="customized-container">
            <div className="customized-wrapper">
                <div className="title-session">
                    <h4>
                        راهنمای استفاده از پنل
                    </h4>
                </div>
                <div className='ms-2 mt-3'>

                    <h5 >
                        تعریف غذا
                    </h5>
                    <p>
                        جهت تعریف غذا، ابتدا دسته بندی غذا ها را ایجاد و سپس محتویات غذا ها را تعریف می کنیم تا در زمان تعریف یک غذا، این موارد قابل انتخاب باشند
                    </p>
                </div>
                <div>
                    <h5 >
                        آپلود تصاویر
                    </h5>
                    <p>
                        جهت بارگزاری سریعتر منو در زمان استفاده توسط مشتریان، نیاز است تا ابعاد و حجم تصاویر استفاده شده کاهش یابند، پیشنهاد می گردد تا حداکثر عرض یا ارتفاع تصاویر 500 پیکسل باشد و جهت کاهش حجم تصاویر از سایت <a target="_blank" href="https://tinypng.com/">tinypng.com</a> استفاده فرمایید.
                    </p>
                </div>
            </div>
        </div>

    )
}

export default HowToUsePanel